import React from "react";
import { Link } from "react-router-dom";
import { Container } from "reactstrap";

const NotFound = () => {
  return (
    <main className="roha-page" style={{ minHeight: "80vh", display: "flex", alignItems: "center" }}>
      <Container>
        <div style={{ textAlign: "center", padding: "5rem 1rem" }}>
          <p className="roha-eyebrow">404 — Page Not Found</p>
          <h1 style={{ fontFamily: "var(--font-heading)", fontSize: "clamp(3rem,8vw,7rem)", fontWeight: 300, color: "var(--color-gold)", lineHeight: 1, marginBottom: "1.5rem" }}>
            Lost in the Gems
          </h1>
          <p style={{ color: "var(--color-muted)", fontSize: "1.1rem", maxWidth: 480, margin: "0 auto 2.5rem" }}>
            The page you are looking for does not exist or has been moved. Let us guide you back to Ethiopia's finest jewellery.
          </p>
          <div style={{ display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap" }}>
            <Link to="/" className="roha-button roha-button--solid">Back to Home</Link>
            <Link to="/products" className="roha-button roha-button--ghost">Shop Collection</Link>
          </div>
        </div>
      </Container>
    </main>
  );
};

export default NotFound;
